<template src="./column-image.html"></template>
<script>

export default {
    name: 'ColumnImage',
    props: {
        column: {
            type: Object,
            default: () => ({}),
        },
        handlers: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['on-image-click'],
    computed: {
        src() {
            return this.column.name;
        }
    },
};

</script>

<style lang="scss" scoped>
.img {
    cursor: zoom-in;
}
</style>
